import styled from "styled-components";
import colors from "../../constants/colors";
import { FieldWrapper } from "../../screens/styles";

export const ServicesFieldWrapper = styled(FieldWrapper)({
  marginBottom: "0.375rem",
});

export const ServicesFieldWrapperHorizontal = styled(ServicesFieldWrapper)({
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem",
});

export const ServicesSingleField = styled("div")({
  flex: 1,
});

export const CheckboxWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  label: {
    fontSize: "0.8125rem",
    color: colors.BLACK,
  },
});

export const CheckboxLabel = styled("label")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.375rem",
  fontSize: "0.8125rem",
  color: colors.BLACK,
  cursor: "pointer",
  lineHeight: 1.3,
});
